var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.movies),function(movie){return _c('v-flex',{key:movie.id,attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('movie-card',{attrs:{"movie":movie}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }